import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, message, Row, Typography, UploadFile } from "antd";
import { useNavigate } from "react-router-dom";
import { FC, useEffect, useState } from "react";
import _ from "lodash";
import MainUpdateCampaign from "./MainUpdateCampaign";
import { backendUrl } from "config";
import dayjs from "dayjs";
import UpdateCampaignFooter from "./UpdateCampaignFooter";
import { useGetNewsById, useUpdateNews } from "hooks/useNews";
import { RequestInputUpdateNews } from "services/interface/news/news.interface";
import { useAppSelector } from "store";

interface UpdateCampaignProps {
    id: string;
  }

const UpdateCampaign: FC<UpdateCampaignProps> = ({ id }) => {
  const navigate = useNavigate();
  const [images, setImages] = useState<UploadFile[]>();
  const [subimages, setSubImages] = useState<UploadFile[]>();

  const [checkIsActive, setCheckIsActive] = useState<boolean>(false);
  const [content, setContent] = useState<string>('')
  const [startValue, setStartValue] = useState<any>(null);
  const [endValue, setEndValue] = useState<any>(null);
  const [productList, setProductList] = useState<any>(null);

  const { data: dataNews } = useGetNewsById(id)

  const { mutate: updateNews, isPending } = useUpdateNews();

  const [form] = Form.useForm();

  const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);
  const onFinish = (values: any) => {

    let new_main_images: any = [];
    if (values.main_images) {
      new_main_images = values.main_images.map((item: any) => {
        return item.id;
      });
    }

    let new_sub_images: any = [];
    if (values.sub_images) {
      new_sub_images = values.sub_images.map((item: any) => {
        return item.id;
      });
    }

    const updateNewsInput : RequestInputUpdateNews = {
      id: id,
      topic: values.topic,
      content: content, //values.content,
      new_type: values.new_type,
      ref_id: factoryId,
      ref_type: "factory",
      main_img: new_main_images,
      sub_img: new_sub_images,
      video_url: values.video_url,
      start_date: values.start_date.format("YYYY-MM-DD"),
      end_date: values.end_date.format("YYYY-MM-DD"),
      is_ads: values.is_ads,
      is_active: values.is_active,
    };

    updateNews(updateNewsInput, {
      onSuccess: (data) => {
        if (data.status === "success") {
          message.success("แก้ไขข่าวสารและโปรโมชั่นสำเร็จ");
          navigate("/campaign");
        }else {
          message.error("แก้ไขข่าวสารและโปรโมชั่นไม่สำเร็จ");
        }
      },
      onError: (error) => {
        message.error("แก้ไขข่าวสารและโปรโมชั่นไม่สำเร็จ");
      },
    });
  };

  useEffect(() => {
    if (dataNews) {
      const data =  dataNews.data.news;
      const main_images_item: UploadFile[] = data.main_image?.map(
        (item: string) => {
          return {
            uid: item,
            name: data.id,
            status: "done",
            id: item,
            url: `${backendUrl}images/${item}`,
          };
        }
      );
            
      const sub_images_item: UploadFile[] = data.sub_image?.map(
        (item: string) => {
          return {
            uid: item,
            name: data.id,
            status: "done",
            id: item,
            url: `${backendUrl}images/${item}`,
          };
        }
      );

      setImages(main_images_item);
      setSubImages(sub_images_item);
      setContent(data.content);

      const start_date = dayjs(data.start_date);
      const end_date = dayjs(data.end_date);
      setStartValue(start_date);
      setEndValue(end_date);
      setProductList(data.products_list)

      form.setFieldsValue({
        topic: data.topic,
        productId: data.products_list.map((item: any) => {
          return item.id.toString();
        }),
        new_type: data.new_type,
        main_images: main_images_item,
        sub_images: sub_images_item,
        start_date: start_date,
        end_date: end_date,
        is_ads: data.is_ads,
        video_url: data.video_url,
        is_active: data.is_active,
      });
    }
  }, [dataNews, form]);

  return (
      <Form
        form={form} onFinish={onFinish}
        labelCol={{
          span: 3 ,
        }}
        layout="horizontal"
        style={{
          // maxWidth: 600,
        }}
      >     
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/campaign");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>แก้ไขข่าวสารและโปรโมชั่น</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll> 
              <MainUpdateCampaign
                form={form}
                subimage={subimages}
                images={images}
                setCheckIsActive={setCheckIsActive}
                checkIsActive={checkIsActive}
                setContent={setContent}
                content={content}
                start_date={startValue} 
                end_date={endValue}
                productList={productList}
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
      <UpdateCampaignFooter loading={isPending} />    
    </Form>
  );
};

export default UpdateCampaign;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
